
import { defineComponent, PropType } from 'vue'
import { Campaign } from '@/types'
import { Selection, ShippingAddress, Payment } from '@/types/order'

import ProductConfirm from './OrderConfirm/ProductConfirm.vue'
import ShippingAddressConfirm from './OrderConfirm/ShippingAddressConfirm.vue'
import PaymentConfirm from './OrderConfirm/PaymentConfirm.vue'
import PriceConfirm from './OrderConfirm/PriceConfirm.vue'

export default defineComponent({
  components: {
    ProductConfirm,
    ShippingAddressConfirm,
    PaymentConfirm,
    PriceConfirm
  },
  props: {
    campaign: {
      type: Object as PropType<Campaign>,
      required: true
    },
    selections: {
      type: Array as PropType<Selection[]>,
      required: true
    },
    shippingAddress: {
      type: Object as PropType<ShippingAddress>,
      required: true
    },
    payment: {
      type: Object as PropType<Payment>,
      required: true
    },
    useRegisteredCreditCard: {
      type: Boolean,
      required: true
    }
  }
})
